import { ReactComponent as Logo } from 'assets/main/banner.svg'

const Third = () => {
    return (
        <div className='flex justify-center items-center gap-6 bg-primary h-60 text-40 text-white'>
            <Logo />
            클릭 한번으로 물류의 맥박을 깨우다
        </div>
    )
}

export default Third